// Translation utilities and constants for pt-BR localization

export const translations = {
  // Common terms
  common: {
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    create: 'Criar',
    add: 'Adicionar',
    remove: 'Remover',
    update: 'Atualizar',
    submit: 'Enviar',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    close: 'Fechar',
    confirm: 'Confirmar',
    yes: 'Sim',
    no: 'Não',
    continue: 'Continuar',
    finish: 'Finalizar',
    skip: 'Pular',
    retry: 'Tentar novamente',
    search: 'Pesquisar',
    filter: 'Filtrar',
    sort: 'Classificar',
    view: 'Visualizar',
    show: 'Mostrar',
    hide: 'Ocultar',
    more: 'Mais',
    less: 'Menos',
    all: 'Todos',
    none: 'Nenhum',
    optional: 'Opcional',
    required: 'Obrigatório',
    select: 'Selecionar',
    browse: 'Navegar',
    manage: 'Gerenciar',
    settings: 'Configurações',
    help: 'Ajuda',
    about: 'Sobre',
    contact: 'Contato',
    support: 'Suporte',
    feedback: 'Feedback',
    privacy: 'Privacidade',
    terms: 'Termos',
    license: 'Licença',
    comingSoon: 'Em breve...',
    dismiss: 'Dispensar'
  },

  // Navigation
  navigation: {
    decks: 'Flashcards',
    quizzes: 'Quizzes',
    match: 'Matches',
    profile: 'Perfil',
    statistics: 'Estatísticas',
    documentation: 'Documentação',
    logout: 'Sair',
    login: 'Entrar',
    register: 'Cadastrar',
    home: 'Início',
    toggleMenu: 'Alternar menu'
  },

  // Quizzes
  quizzes: {
    title: 'Quizzes',
    createQuiz: 'Criar Quiz',
    createFromDeck: 'Criar do Deck',
    createFromScratch: 'Criar do Zero',
    noQuizzesFound: 'Nenhum quiz encontrado',
    startCreatingFirst: 'Comece criando seu primeiro quiz',
    deckBased: 'Baseado em Deck',
    custom: 'Personalizado',
    questions: 'perguntas',
    attempts: 'tentativas',
    averageScore: 'Pontuação Média',
    bestScore: 'Melhor Pontuação',
    play: 'Jogar',
    edit: 'Editar',
    delete: 'Excluir',
    createdOn: 'Criado em',
    lastAttempt: 'Última tentativa',
    quizCreated: 'Quiz criado com sucesso!',
    quizDeleted: 'Quiz excluído com sucesso!',
    confirmDelete: 'Tem certeza de que deseja excluir este quiz?',
    selectDeck: 'Selecionar Deck',
    quizDetails: 'Detalhes do Quiz',
    quizTitle: 'Título do Quiz',
    quizDescription: 'Descrição (Opcional)',
    numberOfQuestions: 'Número de Perguntas',
    createQuizFromDeck: 'Criar Quiz do Deck',
    createCustomQuiz: 'Criar Quiz Personalizado',
    selectDeckToGenerate: 'Selecione um deck para gerar automaticamente perguntas baseadas nas cartas.',
    createCompletelyCustom: 'Crie um quiz completamente personalizado com suas próprias perguntas.',
    creating: 'Criando...',
    next: 'Próximo',
    back: 'Voltar',
    createQuizButton: 'Criar Quiz'
  },

  // Authentication
  auth: {
    login: 'Entrar',
    logout: 'Sair',
    register: 'Cadastrar',
    signIn: 'Entrar',
    signUp: 'Cadastrar',
    email: 'Email',
    password: 'Senha',
    confirmPassword: 'Confirmar senha',
    name: 'Nome',
    firstName: 'Primeiro nome',
    lastName: 'Sobrenome',
    emailAddress: 'Endereço de email',
    emailPlaceholder: 'Endereço de email',
    welcomeTo: 'Bem-vindo ao',
    welcomeBack: 'Bem-vindo de volta!',
    dontHaveAccount: 'Não tem uma conta?',
    alreadyHaveAccount: 'Já tem uma conta?',
    forgotPassword: 'Esqueceu a senha?',
    forgotPasswordTitle: 'Esqueceu a Senha',
    forgotPasswordDescription: 'Digite seu endereço de email e enviaremos um link para redefinir sua senha',
    rememberMe: 'Lembrar de mim',
    signingIn: 'Entrando...',
    creatingAccount: 'Criando conta...',
    demoAccount: 'Conta de demonstração',
    smartFlashcardLearning: 'Aprendizado inteligente com flashcards',
    spacedRepetition: 'com repetição espaçada',
    sendResetLink: 'Enviar Link de Redefinição',
    sending: 'Enviando...',
    backToLogin: 'Voltar ao Login',
    enterEmailForVerification: 'Digite seu endereço de email para receber um novo link de verificação',
    passwordsDoNotMatch: 'As senhas não coincidem',
    newPasswordsDoNotMatch: 'As novas senhas não coincidem',
    pleaseVerifyEmail: 'Por favor, verifique seu endereço de email.',
    mustVerifyEmailBeforePasswordChange: 'Você deve verificar seu endereço de email antes de alterar sua senha.',
    pleaseVerifyEmailToAccess: 'Por favor, verifique seu endereço de email para acessar este recurso.',
    sendVerificationEmail: 'Enviar Email de Verificação',
    resendVerificationEmail: 'Reenviar Email de Verificação',
    switchToLightMode: 'Alternar para modo claro',
    switchToDarkMode: 'Alternar para modo escuro',
    // Change Password
    changePassword: 'Alterar Senha',
    currentPassword: 'Senha Atual',
    newPassword: 'Nova Senha',
    confirmNewPassword: 'Confirmar Nova Senha',
    changing: 'Alterando...',
    emailVerificationRequired: 'Verificação de Email Necessária',
    passwordMinLength: 'A nova senha deve ter pelo menos 6 caracteres'
  },

  // Decks
  decks: {
    myDecks: 'Decks',
    sharedDecks: 'Decks Compartilhados',
    organizeFlashcards: 'Organize seus flashcards em decks para aprendizado focado',
    createDeck: 'Criar Flashcard',
    createNewDeck: 'Criar Novo Flashcard',
    deckName: 'Nome do Flashcard',
    description: 'Descrição',
    enterDeckName: 'Digite o nome do flashcard ...',
    describeDeck: 'Descreva seu flashcard (opcional)',
    creating: 'Criando...',
    study: 'Estudar',
    manage: 'Gerenciar',
    cards: 'flashcards',
    lastStudied: 'Último estudo',
    more: 'mais',
    deleteConfirmTitle: 'Excluir Flashcard',
    deleteConfirmMessage: 'Tem certeza de que deseja excluir este flashcard? Esta ação não pode ser desfeita.',
    deleteConfirmButton: 'Sim, excluir',
    noDeckYet: 'Você ainda não tem flashcards.',
    createFirstDeckMessage: 'Crie seus primeiros flashcards para começar a estudar!',
    createFirstDeck: 'Criar meus primeiros flashcards',
    searchDecks: 'Pesquisar flashcards',
    checkSharedDecksMessage: 'Confira os flashcards compartilhados para começar a estudar ou crie seu próprio flashcard!',
    viewSharedDecks: 'Ver Flashcards Compartilhados',
    backToDecks: 'Voltar',
    copyDeck: 'Copiar Flashcard',
    copying: 'Copiando...',
    deckCopiedSuccess: 'Flashcard copiado com sucesso!',
    failedToCopyDeck: 'Falha ao copiar flashcard',
    noSharedDecksAvailable: 'Nenhum flashcard compartilhado disponível',
    checkBackLater: 'Verifique novamente mais tarde para novos flashcards compartilhados pelos administradores',
    browseSharedDecks: 'Navegar e copiar flashcards compartilhados por administradores',
    previewOnly: 'Apenas Visualização',
    decksUsed: 'flashcards utilizados'
  },

  // Cards
  cards: {
    addCard: 'Adicionar Card',
    addNewCard: 'Adicionar Novo Card',
    createCards: 'Criar cards',
    editCard: 'Editar Card',
    addFirstCard: 'Adicionar Primeiro Card',
    question: 'Pergunta',
    answer: 'Resposta',
    front: 'Frente (Pergunta)',
    back: 'Verso (Resposta)',
    difficulty: 'Dificuldade',
    tags: 'Tags',
    optional: 'Opcional',
    required: 'Obrigatório',
    enterQuestion: 'Digite a pergunta...',
    enterAnswer: 'Digite a resposta...',
    tagPlaceholder: 'tag1, tag2, tag3',
    updateCard: 'Atualizar Card',
    totalCards: 'Total de Cards',
    newCards: 'Cards Novos',
    dueForReview: 'Para Revisar',
    learned: 'Aprendidos',
    reviews: 'Revisões',
    totalReviews: 'Total de Revisões',
    accuracy: 'Precisão',
    getStartedMessage: 'Comece adicionando seu primeiro flashcard a este deck.',
    difficulties: {
      1: '1 - Muito Fácil',
      2: '2 - Fácil',
      3: '3 - Médio',
      4: '4 - Difícil',
      5: '5 - Muito Difícil'
    },
    // Card limit messages
    card: 'card',
    cards: 'cards',
    cardLimitReached: 'Limite de cards atingido',
    cardLimitReachedMessage: 'Você atingiu o limite máximo de {limit} cards para este deck.',
    approachingLimit: 'Aproximando-se do limite:',
    approachingLimitMessage: 'Você tem {remaining} cards restantes neste deck.',
    cardsInDeck: 'cards neste deck',
    cardsUsed: 'cards usados',
    upgradeForUnlimited: 'Faça upgrade para Premium para cards ilimitados.',
    upgradeToUnlimited: 'Faça upgrade para ilimitados',
    upgrade: 'Upgrade'
  },

  // Study
  study: {
    studyDeck: 'Estudar Deck',
    exitStudy: 'Sair do Estudo',
    showAnswer: 'Mostrar Resposta',
    question: 'Pergunta',
    answer: 'Resposta',
    howWellKnown: 'Quão bem você conhecia este card?',
    skip: 'Pular',
    skipCard: 'Pular Card',
    again: 'Novamente (Difícil)',
    easy: 'Fácil',
    perfect: 'Perfeito',
    card: 'Card',
    of: 'de',
    difficulty: 'Dificuldade',
    reviews: 'Revisões',
    completedSession: 'Sessão Concluída!',
    sessionCompleted: 'Sessão Concluída!',
    studiedCards: 'Você estudou {count} cards.',
    noCardsToStudy: 'Nenhum card para estudar',
    allCaughtUp: 'Você está em dia! Todos os cards foram estudados recentemente.',
    noCardsAvailable: 'Nenhum card está disponível para estudo rápido no momento.',
    noCardsAvailableForStudy: 'Nenhum card disponível para estudo',
    noCardsAvailableForQuickStudy: 'Nenhum card disponível para estudo rápido',
    noCardsInDeck: 'Este deck não tem cards disponíveis para estudo.',
    backToDecks: 'Voltar aos Decks',
    quickStudy: 'Estudo Rápido',
    clickToFlipCard: 'Clique no card para virar',
    clickToSeeAnswer: 'Clique para ver a resposta',
    clickToSeeVerse: 'Clique para ver o verso'
  },

  // Messages and notifications
  messages: {
    deckCreated: 'Deck criado com sucesso!',
    flashcardDeleted: 'Flashcard excluído com sucesso!',
    cardAdded: 'Card adicionado com sucesso!',
    cardUpdated: 'Card atualizado com sucesso!',
    cardDeleted: 'Card excluído com sucesso!',
    loginSuccess: 'Login realizado com sucesso!',
    logoutSuccess: 'Logout realizado com sucesso!',
    error: 'Erro',
    success: 'Sucesso',
    warning: 'Aviso',
    info: 'Informação',
    failedToCreate: 'Falha ao criar',
    failedToUpdate: 'Falha ao atualizar',
    failedToDelete: 'Falha ao excluir',
    failedToLoad: 'Falha ao carregar',
    confirmDelete: 'Tem certeza de que deseja excluir este item?',
    deleteConfirmation: 'Tem certeza de que deseja excluir este card?'
  },

  // Time and dates
  time: {
    today: 'Hoje',
    yesterday: 'Ontem',
    tomorrow: 'Amanhã',
    thisWeek: 'Esta semana',
    lastWeek: 'Semana passada',
    thisMonth: 'Este mês',
    lastMonth: 'Mês passado',
    minute: 'minuto',
    minutes: 'minutos',
    hour: 'hora',
    hours: 'horas',
    day: 'dia',
    days: 'dias',
    week: 'semana',
    weeks: 'semanas',
    month: 'mês',
    months: 'meses',
    year: 'ano',
    years: 'anos',
    ago: 'atrás',
    in: 'em'
  },

  // Errors
  errors: {
    notFound: 'Não encontrado',
    deckNotFound: 'Deck não encontrado',
    cardNotFound: 'Card não encontrado',
    pageNotFound: 'Página não encontrada',
    unauthorized: 'Não autorizado',
    forbidden: 'Proibido',
    serverError: 'Erro do servidor',
    networkError: 'Erro de rede',
    unknownError: 'Erro desconhecido',
    validationError: 'Erro de validação',
    requiredField: 'Este campo é obrigatório',
    invalidEmail: 'Email inválido',
    passwordTooShort: 'Senha muito curta',
    passwordsDoNotMatch: 'As senhas não coincidem'
  },

  // Profile
  profile: {
    profile: 'Perfil',
    manageAccount: 'Gerenciar configurações da conta',
    account: 'Conta',
    settings: 'Configurações',
    preferences: 'Preferências',
    statistics: 'Estatísticas',
    history: 'Histórico',
    achievements: 'Conquistas',
    progress: 'Progresso',
    name: 'Nome',
    email: 'Email',
    memberSince: 'Membro desde',
    lastLogin: 'Último login',
    // Tab names
    accountTab: 'Conta',
    achievementsTab: 'Conquistas',
    subscriptionTab: 'Assinatura',
    notificationsTab: 'Notificações',
    securityTab: 'Segurança',
    // Account Information
    accountInformation: 'Informações da Conta'
  },

  // Subscription and Premium
  subscription: {
    upgradeToPremium: 'Upgrade para Premium',
    upgradeRequired: 'Upgrade Necessário',
    unlimitedDecks: 'Decks ilimitados',
    unlimitedCards: 'Cards ilimitados',
    advancedFeatures: 'Recursos avançados',
    premiumBenefits: 'Benefícios Premium',
    subscriptionManagement: 'Gerenciamento de Assinatura',
    currentPlan: 'Plano Atual',
    premium: 'Premium',
    free: 'Gratuito',
    cancelled: 'Cancelado',
    nextBillingDate: 'Próxima Data de Cobrança',
    accessUntil: 'Acesso Até',
    currentUsage: 'Uso Atual',
    decks: 'Decks',
    monthlyStudyTime: 'Tempo de Estudo Mensal',
    cardsStudiedThisMonth: 'Cards Estudados Este Mês',
    minutes: 'minutos',
    cancelSubscription: 'Cancelar Assinatura',
    cancelling: 'Cancelando...',
    retainAccessMessage: 'Você manterá o acesso premium até o final do período de cobrança atual.',
    confirmCancelTitle: 'Tem certeza que deseja cancelar sua assinatura?',
    confirmCancelMessage: 'Você perderá o acesso aos recursos premium no final do período de cobrança atual.',
    subscriptionCancelledSuccess: 'Assinatura cancelada com sucesso. Você manterá o acesso premium até o final do período de cobrança atual.',
    failedToCancel: 'Falha ao cancelar assinatura',
    failedToLoadInfo: 'Falha ao carregar informações da assinatura',
    verified: 'Verificado',
    unverified: 'Não Verificado'
  },

  // Meta information
  meta: {
    title: 'Upmindy - Aprendizado Inteligente',
    description: 'Aplicativo inteligente de flashcards com repetição espaçada. Estude em qualquer lugar, a qualquer hora.',
    keywords: 'flashcards, estudo, repetição espaçada, aprendizado, educação'
  },

  // Text-to-Speech
  tts: {
    playAudio: 'Reproduzir áudio',
    stopAudio: 'Parar áudio',
    pauseAudio: 'Pausar áudio',
    resumeAudio: 'Retomar áudio',
    notSupported: 'Seu navegador não suporta síntese de voz',
    emptyText: 'Nenhum texto para reproduzir',
    error: 'Erro ao reproduzir áudio',
    speaking: 'Reproduzindo...',
    paused: 'Pausado',
    stopped: 'Parado'
  }
};

// Helper function to get nested translation
export const t = (key: string, fallback?: string): string => {
  const keys = key.split('.');
  let value: any = translations;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return fallback || key;
    }
  }
  
  return typeof value === 'string' ? value : fallback || key;
};

// Helper function for pluralization
export const plural = (count: number, singular: string, plural: string): string => {
  return count === 1 ? singular : plural;
};

// Helper function for string interpolation
export const interpolate = (template: string, values: Record<string, any>): string => {
  return template.replace(/\{(\w+)\}/g, (match, key) => {
    return values[key] !== undefined ? values[key] : match;
  });
};
